import React from 'react';
import {Td} from "@chakra-ui/react";
import iso6391 from "iso-639-1";

interface ProjectTableSourceColumnProps {
  source: string;
}

const ProjectTableSourceColumn: React.FC<ProjectTableSourceColumnProps> = ({source}: ProjectTableSourceColumnProps) => {
  return (
    <Td textAlign="center">{iso6391.getName(source)}</Td>
  )
}

export default ProjectTableSourceColumn;